import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'titlecaseHyphenatedValue',
})
export class TitleCaseHyphenatedNamePipe implements PipeTransform {
  transform(stringValue: string): string {
    const regexLowercase = /[A-Z]/g;
    const regexTitlecase = /\b[a-z]/g;

    // lower case the string before performing the titlecasing of the value.
    const lowercasedValue = stringValue.replace(
      regexLowercase,
      (strValue) => {
        return strValue.toLowerCase();
      }
    );
    // titlecase the lowercased value.
    return lowercasedValue.replace(regexTitlecase, (lcStrValue) => {
      return lcStrValue.toUpperCase();
    });
  }
}
